import { useEffect, useState, useRef } from "react";
import "./Branch.css";

const branches = {
  namakkal: {
    city: "Namakkal",
    tag: "🏢 Main Hub",
    color: "#58179e",
    stats: { pilots: "300+", hours: "10K+", batches: "100+" },
    highlights: [
      "DGCA Approved Training",
      "24-Acre Flying Zone",
      "FPV & Mapping Programs",
      "Expert Instructors",
    ],
  },
  bangalore: {
    city: "Bangalore",
    tag: "🚀 Tech Hub",
    color: "#58179e",
    highlights: [
      "Industry Training",
      "Startup Ecosystem",
      "Career Guidance",
      "Advanced Projects",
    ],
  },
};

export default function Branch() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`compact-branch ${isVisible ? "section-visible" : ""}`}
    >
      <div className="compact-header">
        <h2>Our Training Presence</h2>
      </div>

      <div className="cards-grid-container">
        {Object.values(branches).map((data, index) => (
          <div
            key={index}
            className="branch-card-static"
          >
            <div className="card-top-row">
              <h3 className="city-title">{data.city}</h3>
              <span className="city-category-badge">{data.tag}</span>
            </div>

            {data.stats && (
              <div className="stats-dashboard">
                <div className="stat-node">
                  <div className="stat-value">{data.stats.pilots}</div>
                  <div className="stat-lbl">Pilots Trained</div>
                </div>
                <div className="divider-h"></div>
                <div className="stat-node">
                  <div className="stat-value">{data.stats.hours}</div>
                  <div className="stat-lbl">Flight Hours</div>
                </div>
                <div className="divider-h"></div>
                <div className="stat-node">
                  <div className="stat-value">{data.stats.batches}</div>
                  <div className="stat-lbl">Cert. Batches</div>
                </div>
              </div>
            )}

            <div className="highlights-compact">
              {data.highlights.map((h, i) => (
                <div key={i} className="highlight-chip">
                  <span className="check">✓</span>
                  {h}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}